import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Logo } from "@/components/Logo";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";

export const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ login: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.login.trim(), form.password);
      toast.success("Welcome back!");
      nav(user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-zq-cream">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <Link to="/"><Logo /></Link>
          <h1 className="text-3xl font-bold mt-8">Sign in</h1>
          <p className="text-sm text-zq-muted mt-2">Admins use email · Restaurants use Login ID</p>
          <form className="mt-7 space-y-4" onSubmit={submit} data-testid="login-form">
            <div>
              <label className="text-sm font-medium block mb-1">Email or Login ID</label>
              <input
                className="zq-input"
                value={form.login}
                onChange={(e) => setForm({ ...form, login: e.target.value })}
                required
                data-testid="login-id-input"
              />
            </div>
            <div>
              <label className="text-sm font-medium block mb-1">Password</label>
              <input
                type="password"
                className="zq-input"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                data-testid="login-password-input"
              />
            </div>
            <button className="zq-btn zq-btn-primary w-full" disabled={loading} data-testid="login-submit-button">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <p className="text-xs text-zq-muted mt-6">
            New restaurant?{" "}
            <Link to="/pricing" className="text-zq-orange font-medium">Get an account</Link>
          </p>
        </div>
      </div>
      <div className="hidden md:flex flex-1 items-center justify-center zq-hero-bg p-10">
        <div className="text-center max-w-md">
          <h2 className="text-4xl font-bold">Desi flavour.<br/><span className="text-zq-orange">Digital future.</span></h2>
          <p className="text-zq-muted mt-4">Welcome to ZaykaQR — the all-in-one digital menu system for Indian restaurants.</p>
        </div>
      </div>
    </div>
  );
};
